(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $07cb9560063da71a$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"hhfSd":"wheeladmin.9f9aea18.js","2UHmY":"F.6b6d9f7c.png","23bri":"H.861eac15.png","8XmVZ":"C.4155e805.png","9xNlb":"FH.1175a7c9.png","fiuGL":"CF.0bf185a5.png","bt2iu":"CH.e5516591.png","8Xwqf":"CFH.41dd1b2b.png","5V3yX":"check-wheel.d7d33cc6.svg","bt4NG":"x-wheel.7f1336c5.svg","i1vRG":"youshouldnotbehere.22918078.js"}'));


var $3vtib = parcelRequire("3vtib");
const $d42fa48213704d11$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $d42fa48213704d11$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $d42fa48213704d11$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
$3vtib.initialize($d42fa48213704d11$var$APP_ID, $d42fa48213704d11$var$JAVASCRIPT_KEY);
$3vtib.serverURL = $d42fa48213704d11$var$SERVER_URL;
var $d42fa48213704d11$var$funsizer, $d42fa48213704d11$var$currentDataSource, $d42fa48213704d11$var$currentDataEdit, $d42fa48213704d11$var$btnNewS, $d42fa48213704d11$var$attributes, $d42fa48213704d11$var$cats, $d42fa48213704d11$var$sets, $d42fa48213704d11$var$spotModal, $d42fa48213704d11$var$btnSave, $d42fa48213704d11$var$btnCancel, $d42fa48213704d11$var$adminTable, $d42fa48213704d11$var$btnDel, $d42fa48213704d11$var$delModal, $d42fa48213704d11$var$testModal;
var $d42fa48213704d11$var$isEditing = false;
var $f097d6a834d61ad1$exports = {};


$f097d6a834d61ad1$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("2UHmY");


var $844339400853cf5b$exports = {};


$844339400853cf5b$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("23bri");


var $7d7c07e2ae4137c1$exports = {};


$7d7c07e2ae4137c1$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("8XmVZ");


var $1f507956a3864334$exports = {};


$1f507956a3864334$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("9xNlb");


var $d8e10f21151e3d1e$exports = {};


$d8e10f21151e3d1e$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("fiuGL");


var $d6cc83c5551fa958$exports = {};


$d6cc83c5551fa958$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("bt2iu");


var $2aba972bd24c6367$exports = {};


$2aba972bd24c6367$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("8Xwqf");


const $d42fa48213704d11$var$defaultImages = [
    new URL($f097d6a834d61ad1$exports),
    new URL($844339400853cf5b$exports),
    new URL($7d7c07e2ae4137c1$exports),
    new URL($1f507956a3864334$exports),
    new URL($d8e10f21151e3d1e$exports),
    new URL($d6cc83c5551fa958$exports),
    new URL($2aba972bd24c6367$exports)
];
window.addEventListener("load", ()=>{
    $d42fa48213704d11$var$setUIState(false);
    $d42fa48213704d11$var$btnNewS = document.getElementById("btn_new_spot");
    $d42fa48213704d11$var$btnNewS.addEventListener("click", $d42fa48213704d11$var$newSpot);
    $d42fa48213704d11$var$spotModal = document.getElementById("modal_spot");
    $d42fa48213704d11$var$btnCancel = document.getElementById("btn_cancel");
    $d42fa48213704d11$var$btnSave = document.getElementById("btn_save");
    $d42fa48213704d11$var$adminTable = document.getElementById("admin-table");
    $d42fa48213704d11$var$btnCancel.onclick = $d42fa48213704d11$var$cancelSpot;
    $d42fa48213704d11$var$btnSave.onclick = $d42fa48213704d11$var$saveSpot;
    document.getElementById("input_file").addEventListener("change", (e)=>{
        document.getElementById("spot-image").src = URL.createObjectURL(e.target.files[0]);
    });
    $d42fa48213704d11$var$delModal = document.getElementById("modal_delete");
    $d42fa48213704d11$var$btnDel = document.getElementById("btn_delete");
    $d42fa48213704d11$var$btnDel.addEventListener("click", ()=>{
        $d42fa48213704d11$var$delModal.classList.remove("hidden");
    });
    document.getElementById("btn_nm").addEventListener("click", ()=>{
        $d42fa48213704d11$var$delModal.classList.add("hidden");
    });
    document.getElementById("btn_delete_confirm").addEventListener("click", ()=>{
        $d42fa48213704d11$var$setUIState(false);
        $d42fa48213704d11$var$currentDataEdit.destroy().then((r)=>{
            $d42fa48213704d11$var$currentDataSource = $d42fa48213704d11$var$currentDataSource.filter((p)=>p.id != $d42fa48213704d11$var$currentDataEdit.id);
            $d42fa48213704d11$var$currentDataEdit = null;
            $d42fa48213704d11$var$setUIState(true);
            $d42fa48213704d11$var$resetSpotUI();
            $d42fa48213704d11$var$renderSpots();
            $d42fa48213704d11$var$delModal.classList.add("hidden");
            $d42fa48213704d11$var$cancelSpot();
        }, (error)=>{
            $d42fa48213704d11$var$setUIState(true);
            alert("Failed deleting object: " + error);
            $d42fa48213704d11$var$delModal.classList.add("hidden");
        });
    });
    $d42fa48213704d11$var$testModal = document.getElementById("testModal");
    document.getElementById("spot_preview").addEventListener("click", ()=>{
        $d42fa48213704d11$var$togglePreview();
    });
    document.getElementById("btn_tryAgain").addEventListener("click", ()=>{
        $d42fa48213704d11$var$togglePreview();
    });
    $d42fa48213704d11$var$initFunsizer();
});
const $d42fa48213704d11$var$initFunsizer = ()=>{
    $d42fa48213704d11$var$funsizer = $3vtib.User.current();
    if ($d42fa48213704d11$var$funsizer) {
        $d42fa48213704d11$var$setUIState(true);
        $d42fa48213704d11$var$getAttributes().then(()=>{
            $d42fa48213704d11$var$getSpots().then(()=>{
                $d42fa48213704d11$var$renderSpots();
            }).catch(function(e) {
                $d42fa48213704d11$var$handleParseError("Error when fetching Spots", e);
            });
        }).catch(function(e) {
            $d42fa48213704d11$var$handleParseError("Error when fetching Attributes", e);
        });
    } else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
const $d42fa48213704d11$var$setUIState = (enabled)=>{
    if (enabled) {
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 0,
            duration: 0.25
        });
        document.body.style.pointerEvents = "true";
    } else {
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 1,
            duration: 0.25
        });
        gsap.to(document.getElementsByClassName("loader")[0], {
            scale: 0.5,
            duration: 1,
            ease: "bounce.out",
            repeat: -1,
            yoyo: true
        });
        document.body.style.pointerEvents = "false";
    }
};
const $d42fa48213704d11$var$togglePreview = ()=>{
    if ($d42fa48213704d11$var$testModal.classList.contains("hidden")) {
        $d42fa48213704d11$var$testModal.classList.remove("hidden");
        gsap.fromTo($d42fa48213704d11$var$testModal, {
            x: window.innerWidth
        }, {
            x: 0,
            duration: 0.5,
            ease: "expo.out(1, 0.5)"
        });
        document.getElementById("winner_name").innerHTML = document.getElementById("name").value;
        const item = document.getElementById("winner_img");
        item.src = document.getElementById("spot-image").src;
        document.querySelector(".quote-wrapper").classList.remove("hidden");
        document.getElementById("winner_quote").innerHTML = document.getElementById("quote").value.length > 0 ? `"${document.getElementById("quote").value.replace(new RegExp('"', "g"), "")}"` : "";
        document.getElementById("winner_quotee").innerHTML = document.getElementById("quotee").value;
        document.getElementById("winner_address").innerHTML = document.getElementById("address").value;
        document.getElementById("winner_address").href = document.getElementById("map-link").value;
        const menu = document.getElementById("winner_menu");
        menu.classList.remove("hidden");
        menu.innerHTML = document.getElementById("website").value.replace("https://www.", "").replace(".com/", ".com");
    } else $d42fa48213704d11$var$testModal.classList.add("hidden");
};
const $d42fa48213704d11$var$updateDefaultImage = ()=>{
    if ($d42fa48213704d11$var$currentDataEdit && $d42fa48213704d11$var$currentDataEdit.get("Image")) return;
    const fInput = document.getElementById("input_file");
    if (fInput.files.length > 0) return;
    const opts = document.getElementById("category").options;
    var input = document.getElementById("spot-image");
    if (opts[0].selected && opts[1].selected && opts[2].selected) input.src = $d42fa48213704d11$var$defaultImages[6];
    else if (opts[0].selected && opts[1].selected) input.src = $d42fa48213704d11$var$defaultImages[3];
    else if (opts[0].selected && opts[2].selected) input.src = $d42fa48213704d11$var$defaultImages[4];
    else if (opts[1].selected && opts[2].selected) input.src = $d42fa48213704d11$var$defaultImages[5];
    else if (opts[1].selected) input.src = $d42fa48213704d11$var$defaultImages[1];
    else if (opts[0].selected) input.src = $d42fa48213704d11$var$defaultImages[0];
    else input.src = $d42fa48213704d11$var$defaultImages[2];
};
async function $d42fa48213704d11$var$getAttributes() {
    const query = new $3vtib.Query("WheelSpotAttribute");
    try {
        $d42fa48213704d11$var$attributes = await query.find();
        var input = document.getElementById("category");
        const categories = $d42fa48213704d11$var$attributes.filter((a)=>a.get("Type") == "Category");
        categories.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input.add(o);
        });
        [
            ...input.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                $d42fa48213704d11$var$updateDefaultImage();
                return false;
            }, false);
        });
        input = document.getElementById("setting");
        const settings = $d42fa48213704d11$var$attributes.filter((a)=>a.get("Type") == "Setting");
        settings.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input.add(o);
        });
        [
            ...input.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false);
        });
    } catch (error) {
        throw error;
    }
}
/**
 * Spot Calls
 */ async function $d42fa48213704d11$var$getSpots() {
    const query = new $3vtib.Query("WheelSpot");
    query.ascending("Name");
    try {
        $d42fa48213704d11$var$currentDataSource = await query.find();
    } catch (error) {
        throw error;
    }
}
var $9964530e184a714d$exports = {};


$9964530e184a714d$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("5V3yX");


var $4722a187b4bfd549$exports = {};


$4722a187b4bfd549$exports = (parcelRequire("aNJCr")).getBundleURL("hhfSd") + (parcelRequire("iE7OH")).resolve("bt4NG");




const $d42fa48213704d11$var$renderSpots = ()=>{
    const spots = document.getElementById("admin_data");
    spots.innerHTML = "";
    for(var i = 0; i < $d42fa48213704d11$var$currentDataSource.length; i++){
        const spot = $d42fa48213704d11$var$currentDataSource[i];
        const row = document.createElement("div");
        const cellName = document.createElement("div");
        const cellCategory = document.createElement("div");
        const cellHasSnacks = document.createElement("div");
        const cellSetting = document.createElement("div");
        const cellParty = document.createElement("div");
        const cellAddy = document.createElement("div");
        const cellSite = document.createElement("div");
        const cellSaid = document.createElement("div");
        const cellSayer = document.createElement("div");
        const cellHasSnacksIcon = document.createElement("img");
        const cellPartyIcon = document.createElement("img");
        const cellSiteAnchor = document.createElement("a");
        row.classList.add("table-row");
        cellName.classList.add("cell-name");
        cellCategory.classList.add("cell-category");
        cellHasSnacks.classList.add("cell-large-party");
        cellSetting.classList.add("cell-setting");
        cellParty.classList.add("cell-large-party");
        cellAddy.classList.add("cell-address");
        cellSite.classList.add("cell-website");
        cellSaid.classList.add("cell-quote");
        cellSayer.classList.add("cell-said-by");
        spots.append(row);
        row.append(cellName, cellCategory, cellHasSnacks, cellSetting, cellParty, cellAddy, cellSite, cellSaid, cellSayer);
        cellParty.append(cellPartyIcon);
        cellHasSnacks.append(cellHasSnacksIcon);
        cellSite.append(cellSiteAnchor);
        cellName.innerHTML = spot.get("Name");
        var values = $d42fa48213704d11$var$attributes.filter((a)=>spot.get("Category").includes(a.id));
        values.forEach((v)=>{
            const catTag = document.createElement("div");
            catTag.classList.add("tag");
            catTag.innerHTML = v.get("Value");
            if (v.get("Value") === "Happy Hour") catTag.classList.add("happy-hour");
            else if (v.get("Value") === "Coffee") catTag.classList.add("coffee");
            cellCategory.append(catTag);
        });
        let iconURL;
        if (spot.get("HasSnacks") == true) iconURL = new URL($9964530e184a714d$exports);
        else iconURL = new URL($4722a187b4bfd549$exports);
        cellHasSnacksIcon.src = iconURL;
        values = $d42fa48213704d11$var$attributes.filter((a)=>spot.get("Setting").includes(a.id));
        values.forEach((v)=>{
            const setSpan = document.createElement("span");
            setSpan.innerHTML = v.get("Value");
            cellSetting.append(setSpan);
        });
        if (spot.get("LargeParties") == true) iconURL = new URL($9964530e184a714d$exports);
        else iconURL = new URL($4722a187b4bfd549$exports);
        cellPartyIcon.src = iconURL;
        if (spot.get("Address").indexOf(", Austin") > -1) cellAddy.innerHTML = spot.get("Address").substring(0, spot.get("Address").indexOf(", Austin"));
        else cellAddy.innerHTML = spot.get("Address");
        cellSiteAnchor.href = spot.get("WebsiteUrl");
        cellSiteAnchor.setAttribute("target", "_blank");
        cellSiteAnchor.innerHTML = spot.get("WebsiteUrl");
        if (spot.get("Quote")) cellSaid.innerHTML = `"${spot.get("Quote").replace(new RegExp('"', "g"), "")}"`;
        if (spot.get("Quotee")) cellSayer.innerHTML = spot.get("Quotee");
        const clicker = document.createElement("div");
        clicker.classList.add("row");
        clicker.id = spot.id;
        clicker.addEventListener("click", $d42fa48213704d11$var$editSpot);
        row.append(clicker);
    }
};
const $d42fa48213704d11$var$editSpot = (e)=>{
    $d42fa48213704d11$var$isEditing = true;
    $d42fa48213704d11$var$btnDel.classList.remove("hidden");
    $d42fa48213704d11$var$currentDataEdit = $d42fa48213704d11$var$currentDataSource.filter((p)=>p.id == e.target.id)[0];
    if (!$d42fa48213704d11$var$currentDataEdit) return;
    const fInput = document.getElementById("input_file");
    document.getElementById("form-title").innerHTML = "Edit spot";
    fInput.value = "";
    $d42fa48213704d11$var$spotModal.classList.remove("hidden");
    $d42fa48213704d11$var$adminTable.classList.add("hidden");
    var input = document.getElementById("name");
    input.value = $d42fa48213704d11$var$currentDataEdit.get("Name");
    input = document.getElementById("category");
    [
        ...input.options
    ].forEach(function(element) {
        element.selected = $d42fa48213704d11$var$currentDataEdit.get("Category").includes(element.value);
    });
    input = document.getElementById("setting");
    [
        ...input.options
    ].forEach(function(element) {
        element.selected = $d42fa48213704d11$var$currentDataEdit.get("Setting").includes(element.value);
    });
    input = document.getElementById("large-group");
    input.selectedIndex = $d42fa48213704d11$var$currentDataEdit.get("LargeParties") ? 0 : 1;
    input = document.getElementById("has-snacks");
    input.selectedIndex = $d42fa48213704d11$var$currentDataEdit.get("HasSnacks") ? 0 : 1;
    var val = $d42fa48213704d11$var$currentDataEdit.get("Quote");
    input = document.getElementById("quote");
    if (val) input.value = $d42fa48213704d11$var$currentDataEdit.get("Quote");
    else input.value = "";
    var val = $d42fa48213704d11$var$currentDataEdit.get("Quotee");
    input = document.getElementById("quotee");
    if (val) input.value = $d42fa48213704d11$var$currentDataEdit.get("Quotee");
    else input.value = "";
    input = document.getElementById("address");
    input.value = $d42fa48213704d11$var$currentDataEdit.get("Address");
    input = document.getElementById("map-link");
    input.value = $d42fa48213704d11$var$currentDataEdit.get("MapUrl");
    input = document.getElementById("website");
    input.value = $d42fa48213704d11$var$currentDataEdit.get("WebsiteUrl");
    val = $d42fa48213704d11$var$currentDataEdit.get("Image");
    if (val) {
        input = document.getElementById("spot-image");
        input.src = val.url();
    } else $d42fa48213704d11$var$updateDefaultImage();
};
const $d42fa48213704d11$var$newSpot = ()=>{
    $d42fa48213704d11$var$resetSpotUI();
    $d42fa48213704d11$var$isEditing = false;
    $d42fa48213704d11$var$btnDel.classList.add("hidden");
    document.getElementById("form-title").innerHTML = "Add spot";
    $d42fa48213704d11$var$spotModal.classList.remove("hidden");
    $d42fa48213704d11$var$adminTable.classList.add("hidden");
};
const $d42fa48213704d11$var$saveSpot = (e)=>{
    e.stopPropagation();
    const fInput = document.getElementById("input_file");
    let parseFile;
    $d42fa48213704d11$var$cats = [
        ...document.getElementById("category").options
    ].filter((o)=>o.selected);
    $d42fa48213704d11$var$sets = [
        ...document.getElementById("setting").options
    ].filter((o)=>o.selected);
    if (document.getElementById("name").value.length < 1 || $d42fa48213704d11$var$cats.length < 1 || $d42fa48213704d11$var$sets.length < 1 || document.getElementById("address").value.length < 1 || document.getElementById("map-link").value.length < 1) {
        alert("\uD83E\uDD2C Yo, all values are required for a spot. \uD83E\uDD2C");
        return;
    }
    $d42fa48213704d11$var$setUIState(false);
    if (fInput.files.length > 0) {
        const file = fInput.files[0];
        const name = fInput.files[0].name;
        parseFile = new $3vtib.File(name, file);
    }
    if (parseFile) parseFile.save().then(()=>{
        $d42fa48213704d11$var$saveSpotCore(parseFile);
    }, function(error) {
        window.alert("Error while saving image", error);
    });
    else $d42fa48213704d11$var$saveSpotCore();
    $d42fa48213704d11$var$spotModal.classList.add("hidden");
    $d42fa48213704d11$var$adminTable.classList.remove("hidden");
};
const $d42fa48213704d11$var$saveSpotCore = (i)=>{
    const WheelSpot = $3vtib.Object.extend("WheelSpot");
    const wp = new WheelSpot();
    if ($d42fa48213704d11$var$currentDataEdit) wp.set("objectId", $d42fa48213704d11$var$currentDataEdit.id);
    wp.set("Name", document.getElementById("name").value);
    wp.set("Quote", document.getElementById("quote").value);
    wp.set("Quotee", document.getElementById("quotee").value);
    wp.set("Address", document.getElementById("address").value);
    wp.set("MapUrl", document.getElementById("map-link").value);
    wp.set("WebsiteUrl", document.getElementById("website").value);
    wp.set("HasSnacks", document.getElementById("has-snacks").selectedIndex == 0);
    wp.set("LargeParties", document.getElementById("large-group").selectedIndex == 0);
    var vals = $d42fa48213704d11$var$cats.map((c)=>c.value);
    wp.set("Category", vals);
    var vals = $d42fa48213704d11$var$sets.map((c)=>c.value);
    wp.set("Setting", vals);
    if (i) wp.set("Image", i);
    wp.save().then((r)=>{
        $d42fa48213704d11$var$setUIState(true);
        if ($d42fa48213704d11$var$isEditing) $d42fa48213704d11$var$isEditing = false;
        else $d42fa48213704d11$var$currentDataSource.push(r);
        $d42fa48213704d11$var$resetSpotUI();
        $d42fa48213704d11$var$renderSpots();
    }, (error)=>{
        $d42fa48213704d11$var$setUIState(true);
        alert("Failed saving object: " + error);
    });
};
const $d42fa48213704d11$var$cancelSpot = (e)=>{
    if (e) e.stopPropagation();
    $d42fa48213704d11$var$isEditing = false;
    $d42fa48213704d11$var$spotModal.classList.add("hidden");
    $d42fa48213704d11$var$adminTable.classList.remove("hidden");
};
const $d42fa48213704d11$var$resetSpotUI = ()=>{
    $d42fa48213704d11$var$currentDataEdit = null;
    var input = document.getElementById("name");
    input.value = "";
    input = document.getElementById("category");
    for(var i = 0; i < input.options.length; i++)input.options[i].selected = i == 0;
    input = document.getElementById("setting");
    for(var i = 0; i < input.options.length; i++)input.options[i].selected = i == 0;
    input = document.getElementById("large-group");
    input.selectedIndex = 1;
    input = document.getElementById("has-snacks");
    input.selectedIndex = 1;
    input = document.getElementById("quote");
    input.value = "";
    input = document.getElementById("address");
    input.value = "";
    input = document.getElementById("map-link");
    input.value = "";
    input = document.getElementById("website");
    input.value = "";
    input = document.getElementById("spot-image");
    input.src = $d42fa48213704d11$var$defaultImages[0];
};
function $d42fa48213704d11$var$handleParseError(msg, err) {
    switch(err.code){
        case $3vtib.Error.INVALID_SESSION_TOKEN:
            $3vtib.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}

})();
//# sourceMappingURL=wheeladmin.9f9aea18.js.map
